const PARTNER_ID = import.meta.env.VITE_GOOGLE_RESERVE_PARTNER_ID;
const TRACKING_URL = import.meta.env.VITE_GOOGLE_RESERVE_CONVERSION_ENDPOINT;

// Sends rwg token to Google Reserve to track conversions
export function getGoogleReserveCookie(restaurantId?: number) {
    if (!restaurantId) {
        return;
    }

    try {
        return document.cookie
            .split('; ')
            .find((row) => row.startsWith(`_rwg_token_${restaurantId}=`));
    } catch (e) {
        console.error('Unable to get Google Reserve cookie', e);
    }
}

// https://developers.google.com/actions-center/verticals/reservations/bl/add-ons/direct-conversion-tracking#sending
export const trackGoogleReserveConversion = (restaurantId?: number) => {
    try {
        const partnerId = PARTNER_ID;
        const endpoint = TRACKING_URL;

        const rwgTokenCookie = getGoogleReserveCookie(restaurantId);

        if (rwgTokenCookie) {
            const rwgTokenVal = rwgTokenCookie.split('=')[1];
            fetch(endpoint, {
                method: 'POST',
                body: JSON.stringify({
                    conversion_partner_id: partnerId,
                    rwg_token: rwgTokenVal,
                }),
            });
        }
    } catch (e) {
        console.error('Unable to track Google Reserve', e);
    }
};
